<template>
  <div data-test="TFormRowDropDown">
    <div class="flex justify-between">
      <TP2>
        <label :for="props.id" class="block font-semibold">
          {{ props.label }}
        </label>
      </TP2>
      <slot name="additional-label" />
    </div>

    <div class="mt-1">
      <select
        :id="props.id"
        v-model="value"
        :name="props.id"
        :class="[props.hasError ? 'border-danger-500' : '']"
        :required="props.required"
        class="block w-full appearance-none rounded-md border border-neutral-50 px-3 py-2 shadow-sm placeholder:text-gray-400 focus:border-primary-500 focus:outline-hidden focus:ring-primary-500 sm:text-sm"
        :data-test="'TFormRowDropDown-Select-' + dataTestName"
        @input="updateInput"
      >
        <option
          v-if="showEmptyOption"
          :value="null"
          :data-test="
            'TFormRowDropDown-Select-Option-' + dataTestName + '-Empty'
          "
        >
          {{ $t('generic_choose') }}
        </option>
        <option
          v-for="singleItem in props.items"
          :key="singleItem[props.valueIdentifier ?? 'value']"
          :value="singleItem[props.valueIdentifier ?? 'value']"
          :data-test="
            'TFormRowDropDown-Select-Option-' +
            dataTestName +
            '-' +
            singleItem[props.valueIdentifier]
          "
        >
          {{ singleItem[props.textIdentifier ?? 'text'] }}
        </option>
      </select>
    </div>
  </div>
</template>

<script setup lang="ts">
const emit = defineEmits(['update:modelValue']);

const props = defineProps<{
  id: string;
  label: string;
  modelValue: string;
  items: Array<any>;
  hasError?: boolean;
  errorMessage?: string;
  required?: boolean;
  textIdentifier?: string;
  valueIdentifier?: string;
  dataTestName?: string;
  showEmptyOption?: boolean;
}>();

const value = ref(props.modelValue || null);
watch(props, () => {
  if (
    !props.modelValue ||
    !props.items ||
    !props.items.find(
      (item) => item[props.valueIdentifier ?? 'value'] == props.modelValue,
    )
  ) {
    value.value = null;
  } else {
    value.value = props.modelValue;
  }
});

const item = ref(props.modelValue);
if (
  !item.value[props.valueIdentifier ?? 'value'] &&
  props.items &&
  props.items.length > 0
) {
  emit('update:modelValue', item.value);
}

function updateInput(event) {
  if (value === null) {
    emit('update:modelValue', null);
  } else {
    const selectedItem = props.items.find(
      (item) => item[props.valueIdentifier ?? 'value'] == event.target.value,
    );
    if (selectedItem) {
      emit('update:modelValue', selectedItem[props.valueIdentifier ?? 'value']);
    } else {
      emit('update:modelValue', null);
      value.value = null;
    }
  }
}
</script>
